<template>
  <div class="ruKuZuoyeWarp-body app-container">
    <!-- <div class="detailsTitle">
      <h4>新建盘库</h4>
    </div> -->
    <el-breadcrumb separator-class="el-icon-arrow-right" >
      <el-breadcrumb-item :to="{ path: '/inventoryOrder' }">返回</el-breadcrumb-item>
      <el-breadcrumb-item>新建卷板</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 查询条件 -->
    <div ref="searchBox" class="formBox margbot">
      <el-form :inline="true" :model="formData" class="demo-form-inline" ref="formData" label-width="95px" size="mini" style="width:100%">
        <div class="formItemBox">
        <el-form-item label="选择客户:">
          <el-select v-model="formData.customerName" size="mini" placeholder="请选择客户" filterable clearable @change="changeKH">
            <el-option v-for="(item, index) in RKData" :key="index" :label="item.custerName" :value="item.custerName"></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="盘库类型:">
          <el-select v-model="formData.inventoryType" size="mini" placeholder="请选择货物类型" filterable clearable @change="changeKH">
            <el-option v-for="item in inventoryTypeData" :key="item.id" :label="item.name" :value="item.name"></el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="选择仓位:">
          <el-select filterable v-model="warehouseName" size="mini" placeholder="请选择仓位名" clearable multiple @change="changeKH">
            <el-option v-for="(item,index) in addKuwei" :key="index" :label="item.warehouseName" :value="item.warehouseName"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="捆包编号:">
          <el-input  v-model="cargoBarcodes" placeholder="可支持多个" @change="changeKH"></el-input>
        </el-form-item>
        </div>
        <el-form-item>
          <el-button type="primary" size="mini" @click="chaxun" v-if="btnFlg[0]">查询</el-button>
          <el-button type="primary" size="mini" @click="chongzhi" v-if="btnFlg[1]">重置</el-button>
          <el-button type="primary" size="mini" @click="exportClick" v-if="btnFlg[2]">导出</el-button>
          <el-button type="primary" size="mini" @click="anquanmao" v-if="btnFlg[3]">安全帽盘库</el-button>
          <el-button type="primary" size="mini" @click="putong" v-if="btnFlg[3]">普通盘库</el-button>
        </el-form-item>
        <el-form-item>
          <span style="margin-left: 15px">
            总计件数:
            <span style="color: red">{{ totalNumber }}</span> &nbsp;件
          </span>
          <span>
            总计总量:
            <span style="color: red">{{Number(totalAllWeight)}}</span> &nbsp;吨
          </span>
        </el-form-item>
      </el-form>
    </div>
    <!-- 表格 -->
    <div :style="{ height: h }">
      <el-table height="100%" size="mini" border center bordersize="mini" ref="tabref1" :data="tableData" style="width: 100%" class="elTab" :header-cell-style="{ background: '#F5F5F5', color: 'black' }" highlight-current-row>
        <el-table-column fixed type="index" align="center" label="序号" width="60"></el-table-column>
        <el-table-column fixed width="100" label="操作" align="center">
          <template v-slot='scope'>
            <el-button type="text" @click="deleteRow(scope.row)">删除</el-button>
          </template>
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="customerName" label="客户名称" align="center" width="220"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="organizationName" label="仓库名称" align="center" width="220"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="warehouseName" label="仓位名称" align="center"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="cargoBarcode" label="捆包号" align="center"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="number" label="件数" align="center"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="weight" label="重量" width="120" align="center"></el-table-column>
        <!-- <el-table-column :show-overflow-tooltip="true" prop="weight" label="收费标准" align="center"></el-table-column>
      <el-table-column :show-overflow-tooltip="true" prop="stockPoundWeight" label="费用" width="120" align="center"></el-table-column> -->
      </el-table>
    </div>
    <div class="pags" style="text-align: right">
      <el-pagination background @current-change="handleCurrentChange" :current-page="pageInfo.pageNo" :page-size="pageInfo.pageSize" :page-sizes="[10, 20, 30, 40, 50]" layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChange" :total="total"></el-pagination>
    </div>
  </div>
</template>

<script>
import {
  getInventoryList,
  getInventoryNumber,
  getRelationCustomer,
  addInventory,
  zidianKuwei
} from '@/api/wms-stock'
import DonMessage from '@/utils/message'
import { exportExcel } from '@/utils/fileDown.js'
import { getBtn } from '@/utils/getButton'
export default {
  data () {
    return {
      formData: {
        customerName: '',
        customerTaxId: '',
        inventoryType: '',
        warehouseNames: '',
        cargoBarcodes: ''
      },
      cargoBarcodes: '',
      warehouseName: [],
      RKData: [],
      inventoryTypeData: [
        {
          id: 0,
          name: '卷板'
        },
        {
          id: 1,
          name: '建材'
        }
      ],
      pageInfo: {
        pageNo: 1,
        pageSize: 20
      },
      addKuwei: [],
      totalAllWeight: 0,
      totalNumber: 0,
      h: '500px',
      tableData: [],
      btnArr: [
        '003P010101',
        '003P010102',
        '003P010103',
        '003P010104',
        '003P010105'
      ],
      btnFlg: [],
      total: 0,
      delCargoIds: []
    }
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = pH - h - 200 + 'px'
    this.getRelationCustomerS()
    this.zidianKuweiS()
  },
  created () {
    this.btnFlg = getBtn(this.btnArr)
    console.log()
    this.delCargoIds = []
  },
  methods: {
    // 改变客户
    changeKH () {
      console.log(123)
      this.delCargoIds = []
    },
    getInventoryList () {
      this.formData.cargoBarcodes = this.cargoBarcodes.replace(/\n/g, ',')
      this.formData.cargoBarcodes = this.formData.cargoBarcodes.split(',').filter(item => item != '').join(',')
      this.formData.warehouseNames = this.warehouseName.join(',')
      const arr = this.delCargoIds.join(',')
      getInventoryList({
        ...this.formData,
        ...this.pageInfo,
        delCargoIds: arr
      }).then(res => {
        console.log(res)
        this.tableData = res.list
        this.total = res.total
      })
        .catch(error => {
          DonMessage.error(error.message)
        })
    },
    getInventoryNumber () {
      this.formData.cargoBarcodes = this.cargoBarcodes.replace(/\n/g, ',')
      this.formData.warehouseNames = this.warehouseName.join(',')
      const arr = this.delCargoIds.join(',')
      getInventoryNumber({
        ...this.formData,
        delCargoIds: arr
      }).then(res => {
        console.log(res)
        if (res.length == 0) {
          this.totalAllWeight = 0
          this.totalNumber = 0
        } else {
          this.totalAllWeight = res.weight
          this.totalNumber = res.number
        }
      })
        .catch(error => {
          DonMessage.error(error.message)
        })
    },
    chaxun () {
      if ((this.formData.customerName == '' || this.formData.customerName == undefined) && (this.warehouseName.length == 0 && (this.cargoBarcodes == ''))) {
        this.$message.error('请先选择盘库条件')
      } else {
        this.getInventoryList()
        this.getInventoryNumber()
      }
    },
    chongzhi () {
      this.formData = {}
      this.cargoBarcodes = ''
      this.warehouseName = []
      this.delCargoIds = []
      this.tableData = []
      this.totalAllWeight = 0
      this.totalNumber = 0
      this.total = 0
    },
    deleteRow (row) {
      console.log(row)
      this.delCargoIds.push(row.cargoId)
      this.chaxun()
    },
    handleCurrentChange (val) {
      this.pageInfo.pageNo = val
      this.chaxun()
    },
    handleSizeChange (val) {
      this.pageInfo.pageSize = val
      this.chaxun()
    },
    // 导出
    exportClick () {
      this.formData.cargoBarcodes = this.cargoBarcodes.replace(/\n/g, ',')
      this.formData.cargoBarcodes = this.formData.cargoBarcodes.split(',').filter(item => item != '').join(',')
      if (!((this.formData.customerName == '' || this.formData.customerName == undefined) && (this.warehouseName.length == 0) && (this.cargoBarcodes == ''))) {
        const arr = this.delCargoIds.join(',')
        exportExcel(
          this.global.wmsStockName + '/inventory/exportInventoryList',
          { ...this.formData, delCargoIds: arr },
          '新建盘库信息表'
        )
      } else {
        this.$message.error('请先选择盘库条件')
      }
    },
    // 提价panku
    anquanmao () {
      if (!((this.formData.customerName == '' || this.formData.customerName == undefined) && (this.warehouseName.length == 0) && (this.cargoBarcodes == ''))) {
        this.formData.cargoBarcodes = this.cargoBarcodes.replace(/\n/g, ',')
        this.formData.warehouseNames = this.warehouseName.join(',')
        if (this.RKData.filter(item => item.custerName == this.formData.customerName).length > 0) {
          this.formData.customerTaxId = this.RKData.filter(item => item.custerName == this.formData.customerName)[0].taxpayerNumber
        }
        const arr = this.delCargoIds.join(',')
        addInventory({ ...this.formData, inventoryHat: 0, delCargoIds: arr }).then(res => {
          console.log(res)
          this.$message.success('创建成功')
          this.$router.push({ name: 'InventoryOrder' })
          this.delCargoIds = []
        })
          .catch(error => {
            DonMessage.error(error.message)
          })
      } else {
        this.$message.error('请先选择盘库条件')
      }
    },
    // 提价panku
    putong () {
      if (!((this.formData.customerName == '' || this.formData.customerName == undefined) && (this.warehouseName.length == 0) && (this.cargoBarcodes == ''))) {
        this.formData.cargoBarcodes = this.cargoBarcodes.replace(/\n/g, ',')
        this.formData.warehouseNames = this.warehouseName.join(',')
        if (this.RKData.filter(item => item.custerName == this.formData.customerName).length > 0) {
          this.formData.customerTaxId = this.RKData.filter(item => item.custerName == this.formData.customerName)[0].taxpayerNumber
        }

        const arr = this.delCargoIds.join(',')
        addInventory({ ...this.formData, inventoryHat: 1, delCargoIds: arr }).then(res => {
          console.log(res)
          this.$message.success('创建成功')
          this.$router.push({ name: 'InventoryOrder' })
          this.delCargoIds = []
        })
          .catch(error => {
            DonMessage.error(error.message)
          })
      } else {
        this.$message.error('请先选择盘库条件')
      }
    },
    // 字典-查询客户
    getRelationCustomerS () {
      getRelationCustomer({
        // groupNo: "change_status"
      })
        .then((res) => {
          this.RKData = res
        })
        .catch((err) => {
          this.$message({ message: err.message, type: 'error' })
        })
    },
    // 字典--库位
    zidianKuweiS () {
      zidianKuwei({})
        .then((res) => {
          this.addKuwei = res
        })
        .catch((err) => {
          console.log(err)
        })
    }
  }

}
</script>

<style lang='less' scoped>
.messages {
  font-size: 16px;
}
.inpBox {
  .el-form-item {
    margin-left: 10px;
    margin-bottom: 0px;
  }
}
 .formItemBox{
    /deep/.el-form-item{
      width: 24%;
    }
  }
</style>
